<div class="col-sm-12 form-group nopad" style="text-align: center;">
    <div>
        <br>
        <!-- Webcam Component -->
        <webcam
            [height]="300"
            [width]="300"
            [trigger]="triggerObservable"
            (imageCapture)="handleImage($event)"
            *ngIf="showWebcam"
            [allowCameraSwitch]="allowCameraSwitch"
            [switchCamera]="nextWebcamObservable"
            [videoOptions]="videoOptions"
            [imageQuality]="1"
            (cameraSwitched)="cameraWasSwitched($event)"
            (initError)="handleInitError($event)">
        </webcam>
        <br />
        
        <!-- Capture Button -->
        <button class="btn btn-info btn-sm actionBtn1" (click)="triggerSnapshot()">Take Picture</button>
    </div>
</div>
